var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyState({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 197,
    viewBox: "0 0 212 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.091,
    cy: 97.042,
    r: 97.042,
    fill: "#ECEEF5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "tagwwfj9na",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 212,
    height: 193
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.775 116.078c-6.87 24.586-16.892 41.467-38.549 57.089a13.63 13.63 0 0 1-4.671 2.144l-81.872 20.468c-1.446.361-2.94.495-4.428.395l-52.839-3.544a14.314 14.314 0 0 1-10.05-5.135l-10.75-12.944A14.311 14.311 0 0 1 .34 164.549L9.15 18.044C9.65 9.72 17.13 3.587 25.39 4.727l93.371 12.89a14.31 14.31 0 0 0 4.328-.064l71.213-11.966c9.062-1.523 17.2 5.76 16.762 14.938-1.926 40.377-3.456 92.571-4.289 95.553z",
    fill: "#ECEEF5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tagwwfj9na)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.544,
    y: 39.89,
    width: 184.373,
    height: 146.303,
    rx: 3.25,
    transform: "rotate(-6.956 12.544 39.89)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEDF3",
    d: "m41.865 94.695 55.117-6.724.572 4.69-55.117 6.724zM48 126.562l55.117-6.724.573 4.69-55.118 6.724z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.615 103.422a3.977 3.977 0 0 1-3.728-1.461 3.98 3.98 0 0 1-.596-3.955 4.009 4.009 0 0 1 3.132-2.495 4.003 4.003 0 0 1 3.712 1.463 3.98 3.98 0 0 1 .597 3.955 3.971 3.971 0 0 1-3.117 2.493zm-2.036-5.019c-.131.178-.096.41.08.526l.835.617-.617.835c-.131.178-.096.41.08.525a.342.342 0 0 0 .51-.076l.616-.836.835.617c.178.131.41.096.526-.08.133-.162.098-.394-.08-.525l-.835-.617.617-.835c.133-.163.098-.394-.08-.526a.387.387 0 0 0-.525.08l-.617.835-.835-.616a.368.368 0 0 0-.51.076z",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.507 78.148a1.5 1.5 0 0 1 1.707 1.26l.009.061a.44.44 0 0 1-.383.5l-2.086.315a.428.428 0 0 1-.498-.368l-.009-.061a1.5 1.5 0 0 1 1.26-1.707zm-3.075 2.138a.481.481 0 0 1 .695-.105l1.138.84c.018.013.033.01.036.026.2-.14.453-.242.716-.281l1.73-.261a1.64 1.64 0 0 1 .752.06l.026-.035.84-1.138a.481.481 0 0 1 .695-.105c.229.155.278.48.105.695l-.84 1.138c.002.016-.013.018-.026.036.121.171.213.363.263.592l1.004-.151a.503.503 0 0 1 .569.42.514.514 0 0 1-.42.569l-.989.149c.056.37.017.74-.088 1.088.033.01.068.037.104.063l1.138.84c.229.155.278.48.105.695a.483.483 0 0 1-.696.105l-1.12-.827a2.567 2.567 0 0 1-1.313.83l-.558-3.708a.258.258 0 0 0-.285-.21c-.124.018-.229.16-.21.284l.559 3.709a2.573 2.573 0 0 1-1.484-.409l-.826 1.12a.483.483 0 0 1-.696.105.482.482 0 0 1-.104-.695l.839-1.138c.027-.036.053-.071.081-.091a2.477 2.477 0 0 1-.392-1.031l-.989.148a.494.494 0 0 1-.569-.42.504.504 0 0 1 .42-.568l.989-.15a1.611 1.611 0 0 1 .079-.628l-.035-.026-1.138-.84a.482.482 0 0 1-.105-.695z",
    fill: "#233145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEDF3",
    d: "m23 48.266 18.023-2.199.904 7.41-18.023 2.2zM26 70.949l78.83-9.618.747 6.122-78.83 9.618zM27.916 84.313l20.473-2.498.472 3.868-20.473 2.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6DAE4",
    d: "m16.229 63.215 181.454-22.138.04.33L16.269 63.546z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEDF3",
    d: "m43 102.725 127.79-15.59 1.212 9.94-127.79 15.591zM49.135 134.59 176.925 119l1.212 9.94-127.79 15.591z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 131,
    r: 4,
    fill: "#EAEDF3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 115,
    r: 4,
    fill: "#EAEDF3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.9d5c7dcfada969f120becd1dc1278842.svg";
export { ForwardRef as ReactComponent };